import React from 'react';

const chestOptions = ['Average', 'Muscular', 'Thin', 'Stocky'];

const StepChestShoulders = ({ data, setData, onNext, onPrev }) => {
  const handleSelect = (value) => {
    setData(prev => ({
      ...prev,
      chestShoulders: value
    }));
  };

  const handleSkip = () => {
    setData(prev => ({
      ...prev,
      chestShoulders: null
    }));
    onNext();
  };

  return (
    <main className="rbt-main-wrapper">
      <div className="container custom-checkout-container">
        <div className="row">
          <div className="">
            <div className="chest-shoulders-container">
              <h3 className="chest-shoulders-title">Which best describes your chest & shoulders?</h3>

              {chestOptions.map((option) => (
                <button
                  key={option}
                  className={`chest-shoulders-btn ${data.chestShoulders === option ? 'active' : ''}`}
                  onClick={() => handleSelect(option)}
                >
                  {option}
                </button>
              ))}

              <button className="chest-shoulders-skip mt-3" onClick={handleSkip}>
                I'm not sure, skip this question
              </button>

              <div className="nav-buttons mt-4">
                <button className="chest-shoulders-prev-btn" onClick={onPrev}>
                  Prev
                </button>
                <button
                  className="chest-shoulders-next-btn"
                  onClick={onNext}
                  disabled={!data.chestShoulders}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default StepChestShoulders;
